import { TCompanyRolePermissionsMe } from 'redux-store/api/company-roles';
import { IHasPermission, PermissionCheckRule, SinglePermissionProps } from './types';

export const normalizeSinglePermission = ({
  scope,
  subject,
}: SinglePermissionProps): PermissionCheckRule[] => [
  {
    subject,
    scopes: Array.isArray(scope) ? scope : [scope],
  },
];

export const checkUserPermissions = ({
  userPermissions,
  props,
}: {
  userPermissions: TCompanyRolePermissionsMe;
  props: IHasPermission;
}): boolean => {
  //TODO: Need additional logic for checking all scopes for a specific subject
  const hasRequiredScope = (rule: PermissionCheckRule): boolean =>
    rule.scopes.some((scope) => userPermissions[rule.subject]?.[scope]);

  if (props.type === 'single') {
    const rules = normalizeSinglePermission(props);
    return rules.some(hasRequiredScope);
  }

  return props.match === 'all'
    ? props.permissionRules.every(hasRequiredScope)
    : props.permissionRules.some(hasRequiredScope);
};
